module.exports = __webpack_public_path__ + "static/diy_recipe_gummy_bears-65dc4497d95707568a7fc193d92c44e0.pdf";